import { SavedInvestigationsCardView } from '@/components/case-overview/SavedInvestigationsCardView'
import { useInvestigationsStore } from '@/stores/investigations-store-provider'

/**
 * Connected saved-investigations summary for the case overview. Reads the
 * saved list from the investigations store and feeds the pure
 * {@link SavedInvestigationsCardView}.
 */
export function SavedInvestigationsCard({ caseId }: { caseId: string }) {
  const saved = useInvestigationsStore(s => s.saved)
  return <SavedInvestigationsCardView saved={saved} caseId={caseId} />
}
